import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  :root {
    --gray-10: #f2f2f2;
    --gray-50: #f4f4f4;
    --gray-100: #f8f8f8;
    --gray-200: #e5e5e5;
    --gray-400: #c4c4c4;
    --gray-500: #BDBDBD;
    --gray-550: #B7B2B5;
    --gray-600: #777;
    --gray-800: #4f4f4f;
    --white: #fff;
    --purple-100: #FFDEE0;
    --purple-500: #931B80;
    --pink-200: #E6037F;
    --pink-400: #99175C;
    --pink-500: #963356;
    --pink-600: #750e40;
    --blue-100: #56ccf2;
    --blue-400: #2d9cdb;
    --blue-500: #2f80ed;
    --green-200: #4cda73;
    --green-400: #00a32d;
    --red-100: #F5C0C3;
    --red-200: #eb5757;
    --red-400: #f5222d;
    --yellow-400: #f2c94c;
    --orange-400: #f2994a;
    --black: #000;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html{
    scroll-behavior: smooth;
    overflow-x: hidden;
    
    @media (max-width: 1080px){
      font-size: 93.75%;
    }

    @media (max-width: 720px){
      font-size: 87.5%;
    }
  }

  body{
    background:var(--white);
    -webkit-font-smoothing: antialiased;
  }

  body, input, textarea, button {
    font-family: 'Open Sans', sans-serif;
  }

  button{
    cursor: pointer;
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Icon Styles */
  .icon-button-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-button{  
    max-width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 25px;
    border-radius: 20px;
    font-size: 12px;
  }

  .icon-circle{
    width: 38px;
    height: 38px;
    border-radius: 50%;
  }

  .icon-arrow{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    margin-right: -30px;
    transition: ease all 0.3s;
  }

  .icon-timer{
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      margin-right: 0.4rem;
    }
  }

  .icon-ok{
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      margin-left: 0.5rem;
    }
  }

  .icon-alert{
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      margin-left: 0.5rem;
    }
  }

  .icon-alert-red{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 5px;

    img{
      margin-left: 0.5rem;
    }
  }

  .icon-agent{
    font-size: 18px;
    color: #fff;
  }

  .icon-agent-ag{
    background: #2D9CDB;
  }

  .icon-agent-kt{
    background: #2F80ED;
  }

  .icon-negative{
    color: #000;
    padding: 4px 55px;
    font-weight: 600;
    background: #6FCF97;
  }

  .icon-positive{
    color: #fff;
    font-weight: 600;
    padding: 4px 45px;
    background: #000;
  } 

  .icon-red{
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    max-width: 50px;
    background: var(--red-400);
  } 
  .icon-yellow{
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    max-width: 50px;
    background: var(--yellow-400);
  } 
  .icon-green{
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    max-width: 50px;
    background: var(--green-400);
  } 
  .icon-orange{
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    max-width: 50px;
    background: var(--orange-400);
  } 

  .icon-round-red{
    color: #fff;
    padding: 1rem;
    font-size: 16px;
    font-weight: 600;
    max-width: 50px;
    background: var(--red-400);
  } 
  .icon-round-green{
    color: #fff;
    padding: 1rem;
    font-size: 16px;
    font-weight: 600;
    max-width: 50px;
    background: var(--green-400);
  } 
  .icon-round-orange{
    color: #fff;
    padding: 1rem;
    font-size: 16px;
    font-weight: 600;
    max-width: 50px;
    background: var(--orange-400);
  } 

  .icon-plus-content{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-plus{
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
  } 

  .icon-link{
    text-decoration: none;
  }

  .boleto-red {
    color: var(--red-400)
  }

  .boleto-green {
    color: var(--green-400)
  }

  .icon-realize{
    max-width: 155px;
    height: 35px;
    color: var(--pink-400);
    font-weight: 600;
    font-size: 14px;
    border-radius: 0.5rem;
    background: var(--gray-200);
  }

  /* Modal Styles */
  .react-modal-overlay {
    background: rgba(0, 0, 0, 0.25);

    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-modal-header{
    background-color: var(--pink-400); 
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 10px;
    border-radius: 0.5rem 0.5rem 0 0;

    h3{
      color: var(--white);
      font-size: 1.125rem;
      font-weight: 400;
      margin-right: 0.625rem;
      cursor: pointer;
    }

    img{
      margin-right: 1rem;
      cursor: pointer;
    }
  }

  .react-modal-header-graphics{
    background-color: var(--pink-400); 
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.5rem 0.5rem 0 0;

    .react-modal-header-graphics-text-left{
      display: flex;
      align-items: center;
      margin-left: 1rem;
    }

    h3{
      color: var(--white);
      font-size: 1.125rem;
      font-weight: 400;
      margin-right: 0.625rem;
    }

    img{
      margin-right: 1rem;
      cursor: pointer;
    }
  }

  .react-modal-content {
    width: 100%;
    height: 100vh;
    max-height: 96vh;
    max-width: 604px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }
  
  .react-modal-content-guide-info-ai-rumi {
    width: 100%;
    height: 80vh;
    max-height: 96vh;
    max-width: 604px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }

  .react-modal-content-reports {
    width: 100%;
    height: 100vh;
    /* max-height: 96vh; */
    max-height: calc(100vh - 10px);
    max-width: 630px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    overflow-y: auto;
  }

  .react-modal-content-validate {
    width: 100%;
    max-width: 304px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }
  
  .react-modal-content-validate-container{
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;

    h3{
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 2rem;
    }

    button{
      height: 3rem;
      width: 100%;
      background: var(--pink-400);
      border: none;
      border-radius: 0.5rem;
      transition: filter 0.2s;
  
      color: var(--white);
      font-size: 1rem;
      font-weight: 700;
  
      :hover{
        filter: brightness(0.9);
      }
    }
  }

  .react-modal-content-help-section {
    width: 100%;
    /* height: 100vh; */
    max-height: 85vh;
    max-width: 800px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }

  .react-modal-content-alert {
    width: 100%;
    max-width: 360px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }

  .react-modal-content-graphics {
    width: 100%;
    /* height: 100vh; */
    /* max-height: 96vh; */
    /* max-height: calc(100vh - 500px); */
    max-width: 630px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    /* overflow-y: auto; */
  }

  .react-modal-content-reports {
    width: 100%;
    max-width: 631px;
    height: 85vh;
    background: var(--white);
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }

  .react-modal-help-content{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    position: relative;
    height: 90%;
    width: 100%;

    h2{
      width: 95%;
      text-align: center;
      font-size: 1.75rem;
      font-weight: 700;
    }

    h3{
      width: 90%;
      text-align: center;
      font-size: 1.125rem;
      font-weight: 700;
    }

    h4{
      margin-top: 1.5rem;
      max-width: 229px;
      text-align: center;
      font-size: 1.125rem;
      font-weight: 500;
    }

    iframe{
      margin: 1rem;
    }

    img{
      width: auto;
      height: 100%;
      position: absolute;
      top: 5px;
      object-fit: contain;
    }

    .react-modal-help-viewer-button{
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      margin-top: 1rem;
      width: 100%;
    
      button{
        position: relative;
        width: 100%;
        max-width: 240px;
        border: none;
        height: 3rem;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        background: var(--pink-400);
        border-radius: 0.5rem;
        font-size: 1rem;
        font-weight: 600;
        padding: 0.6rem 1.6rem;
        transition: filter 0.2s;
        
        :hover{
          filter: brightness(0.85);
        }
      }

      a{
        color: var(--white);
        text-decoration: none;
      }
    } 
  }
  
  .react-modal-guide-ai{
    display: flex;
    flex-direction: column;
    justify-content: center;
  
    h3{
        color: #0B1B40;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
    }
    
    button{
        border: none;
        background: transparent;
    }
    
    p{
        color: #0B1B40;
        text-align: center;
        margin-bottom: 10px;
        padding: 10px;
        strong{
            color: #E6037F;
        }
    }
    
     .icon-question-circle{
        height: 15px;  
        filter: invert(14%) sepia(76%) saturate(3343%) hue-rotate(312deg) brightness(100%) contrast(94%);      
    }
  }
  
  .react-modal-guide-ai-welcome-rumi{
    display: flex;
    flex-direction: column;
    justify-content: center;
  
    h3{
        color: #0B1B40;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        strong{
            color: #E6037F;
            margin-left: 2px;
        }
    }
    
    button{
        border: none;
        background: transparent;
    }
    
    p{
        color: #0B1B40;
        text-align: center;
        margin-bottom: 10px;
        padding: 10px;
        strong{
            color: #E6037F;
        }
    }
  }
  
  .react-modal-content-disagree-result-ai{
    width: 100%;
    height: 96vh;
    max-height: 96vh;
    max-width: 604px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }
  
  .react-dialog-used-result-ai{
    width: 100%;
    height: 30vh;
    max-height: 96vh;
    max-width: 604px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }
  
  .modal-dialog-used-result-rumi{
    display: flex;
    justify-content: center;
  }
  
  .react-modal-before-attachment-photo-content{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    position: relative;
    height: 50%;
    width: 100%;

    img{
      width: auto;
      height: 70%;
      position: absolute;
      top: 5px;
      object-fit: contain;
    }
  }
  
  .modal-before-attachment-photo {
    display: flex;
    justify-content: center;
  }
  
  .modal-before-attachment-photo-welcome-rumi{
    display: flex;
    justify-content: center;
    a{
        color: white;
        text-decoration: none;
    }
  }
  
  .react-modal-dialog-result-rumi-content{
    display: flex;
    flex-direction: column;
    margin: 18px;
    
    .agents-find-out-rumi{
        display: flex;
        .agent-find-out{
            margin: 5px;
            border-radius: 8px;
            padding: 10px;
        }
    }
    
    .title-dialog{
        text-align: center;
    }
  }
  
  .button-dialog-used-result-rumi{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    width: 110px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    color: var(--white);
    border-radius: 6px;
    background: var(--pink-400);
    padding: 10px;
    transition: filter 0.2s;

    :hover{
      filter: brightness(0.9);
    }
  }
  
  .button-attachment-modal-before{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 350px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    color: var(--white);
    border-radius: 6px;
    background: var(--pink-400);
    padding: 10px;
    transition: filter 0.2s;

    :hover{
      filter: brightness(0.9);
    }

    img{
        margin-left: 10px;
    }

  }

  .react-modal-help-content-img{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    position: relative;
    height: 50vh;
    width: 100%;

    .img-pdf{
      margin-top: 1rem;
      object-fit: cover;
      height: 90%;
      position: absolute;
    }
  }

  .react-modal-content-test{
    padding: 2rem 2rem 0 2rem;

    h3{
      font-size: 1.2rem;
      font-weight: 700;
      margin-bottom: 1.6rem;
    }

    > div{
      display: flex;
      align-items: center;  
      margin-bottom: 1.6rem;
    }

    input{
      display: flex;
      align-items: center;
      justify-content: center;
      appearance: none;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid var(--pink-200);
      border-radius: 50%;
      background: transparent;
      transition: background 0.2s;
      outline: none;
      cursor: pointer;

      &:focus {
        box-shadow: 0 0 0.5rem var(--pink-200);
      }

      &:before {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--pink-200);
        transition: opacity 0.2s;
        opacity: 0;
        position: absolute;
      }

      &:checked {
        &:before {
          opacity: 1;
        }
      }
    }

    label{
      font-size: 1.155rem;
      font-weight: 600;
      padding-left: 0.8rem;
      color: black;
      line-height: 1;
      cursor: pointer;
      }
  }

  .react-modal-buttons{
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin-top: 2rem; */
    margin-bottom: 2rem;
    gap: 0.6rem;

    button{
      font-size: 1rem;
      width: 155px;
      font-weight: 700;
      color: var(--black);
      border: 1px solid var(--gray-600);
      background: var(--white);
      border-radius: 0.5rem;
      padding: 0.8rem 2rem;
      margin-bottom:0;
      margin-top:30px;
      :hover{
        border: none;
        background: var(--pink-400);
        color: var(--white);
      }
    }
  }

  .react-modal-buttons-content{
    display: flex;
    gap: 1rem;
  }

  .react-modal-help-content-graphics{
    margin-top: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    label{
      margin-top: 1rem;
      font-size: 1rem;
      margin-bottom: 0.5rem;
      font-weight: 600;
    }

    input{
      width: 100%;
      max-width: 300px;
      border-radius: 0.5rem;
      padding: 0.5rem;
      font-size: 1rem;
      font-weight: 600;
    }

    .react-modal-help-content-buttons{
      display: flex;
      flex-direction: row;

      button{
        /* margin-top: 1rem; */
        width: 180px;
        height: 48px;
        border: 1px solid var(--gray-200);
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        background: var(--white);
        border-radius: 0.5rem;
        color: var(--gray-800);
        font-size: 1rem;
        font-weight: 600;

        &.activeFilterGraph,
        :hover{
          background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
          color: var(--white);
          border: none;
        }
      }
    }
  }

  .react-modal-help-content-reports{
    margin: 1.8rem;
    display: flex;
    flex-direction: column;
    height: 85%;

    label{
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.6rem;
    }

    input{
      width: 100%;
      max-width: 362px;
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 8px;
      padding: 1rem;
    }
    
    h4:first-child{
      margin-top: 0.4rem;
      font-size: 1rem;
      font-weight: 600;
    }

    h4{
      margin-top: 3rem;
      font-size: 1rem;
      font-weight: 600;
    }
  }

  .react-modal-help-content-graphs{
    /* margin: 1.8rem; */
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 150px);
    overflow-y: auto;
    height: 85%;

    label{
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.6rem;
    }

    input{
      width: 100%;
      /* max-width: 472px; */
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 8px;
      padding: 1rem;
    }

    h4{
      margin-top: 2rem;
      display: flex;
      justify-content: center;
      font-size: 1rem;
      font-weight: 600;
    }

    .react-modal-help-content-buttons{
      display: flex;
      flex-direction: row;

      button{
        /* margin-top: 1rem; */
        width: 180px;
        height: 48px;
        border: 1px solid var(--gray-200);
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        background: var(--white);
        border-radius: 0.5rem;
        color: var(--gray-800);
        font-size: 1rem;
        font-weight: 600;

        &.activeFilterGraph,
        :hover{
          background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
          color: var(--white);
          border: none;
        }
      }
    }
  }

  .react-modal-help-content-graphs-agents{
    margin: 1.8rem;
    display: flex;
    flex-direction: column;
    height: 85%;

    label{
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.6rem;
    }

    input{
      width: 100%;
      /* max-width: 362px; */
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 8px;
      padding: 1rem;
      font-size: 1rem;
    }
    
    h4:first-child{
      margin-top: 0.4rem;
      font-size: 1rem;
      font-weight: 600;
    }

    h4{
      margin-top: 3rem;
      font-size: 1rem;
      font-weight: 600;
    }
  }


  .react-modal-help-content-reports-buttons{
    margin-left: 1rem;
    
    button{
      margin-top: 0.6rem;
      border: 1px solid var(--gray-200);
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
      background: var(--white);
      border-radius: 0.5rem;
      color: var(--gray-400);
      font-size: 1rem;
      font-weight: 600;
      padding: 0.6rem 1.6rem;

      margin-right: 1.8rem;

      &.activeReport,
      :hover{
        background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
        color: var(--white);
      }
    }
  }
  .react-modal-help-content-graphs-buttons{
    /* margin-left: 1rem; */
    
    button{
      margin-top: 0.6rem;
      border: 1px solid var(--gray-200);
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
      background: var(--white);
      border-radius: 0.5rem;
      color: var(--gray-400);
      font-size: 1rem;
      font-weight: 600;
      padding: 0.6rem 1.6rem;

      margin-right: 1.2rem;

      &.activeReport,
      :hover{
        background: linear-gradient(231.01deg, var(--pink-200) 20.98%, var(--pink-400) 90.65%);
        color: var(--white);
        border: none;
      }
    }
  }

  .react-modal-help-content-filter-button{
    width: 100%;
    max-width: 379px;
    height: 48px;
    background: var(--pink-400);
    margin-top: 1.3125rem;
    margin-bottom: 1.5rem;
    border: none;
    border-radius: 0.5rem;
    transition: filter 0.2s;

    color: var(--white);
    font-size: 1rem;
    font-weight: 700;

    :hover{
      filter: brightness(0.9);
    }
  }

  .react-modal-help-content-filter-export-button{
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;

    button{
      width: 90%;
      height: 3rem;
      background: var(--pink-400);
      margin-top: 3.3125rem;
      margin-bottom: 1rem;
      border: none;
      border-radius: 0.5rem;
      transition: filter 0.2s;
  
      color: var(--white);
      font-size: 1rem;
      font-weight: 700;
  
      :hover{
        filter: brightness(0.9);
      }
    }
  }

  .react-modal-close {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    border: 0;
    background: transparent;
    transition: filter 0.2s;

    &:hover{
      filter: brightness(0.8)
    }
  }
  
  .react-modal-alert{
    border: 1px solid var(--gray-600);
    border-radius: 50%;
    background-color: var(--white);
    padding: 0.6rem;
    margin-top: -3.5rem;
    margin-bottom: 1.8rem;

    img{
      display: flex;
      align-items: center;
    }
  }

  .react-modal-ok {
    border: 1px solid var(--gray-600);
    border-radius: 50%;
    background-color: var(--white);
    padding: 1.5rem;
    margin-top: -3.5rem;
    margin-bottom: 1.8rem;
    height: 90px;
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;

    img{
      display: flex;
      align-items: center;
      position: unset;
      width: 60%;
      height: 40%;
    }
  }

  .side-A{
    color: var(--white);
    background: var(--pink-400);
    padding: 0.3rem 0.7rem;
    border-radius: 50%;
  }

  .side-B{
    color: var(--white);
    background: var(--pink-200);
    padding: 0.3rem 0.7rem;
    border-radius: 50%;
    font-weight: 700;
  }
  
  .react-modal-content-filter {
    width: 100%;
    height: 80vh;
    overflow: auto;
    max-width: 360px;
    background: var(--white);
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  }


  .react-modal-filter-content{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    h2{
      max-width: 371px;
      text-align: center;
      font-size: 1.75rem;
      font-weight: 700;
    }

    h3{
      max-width: 219px;
      text-align: center;
      font-size: 1.125rem;
      font-weight: 700;
    }

    h4{
      max-width: 229px;
      text-align: center;
      font-size: 1.125rem;
      font-weight: 500;
    }

    iframe{
      margin: 3rem;
    }
  }

  .react-modal-filter-header{    
    width: 100%;
    background: var(--pink-400);
    text-align: left;
    color: white;

    h4{
      padding: 1em;
      max-width: 229px;
      text-align: left;
      font-size: 1.125rem;
      font-weight: 500;
    }
  }

  .react-modal-filter-buttons{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
    gap: 0.6rem;
    width: 80%;

    button{
      font-size: 1rem;
      width: 155px;
      font-weight: 700;
      color: var(--black);
      border: 1px solid var(--gray-200);
      background: var(--white);
      border-radius: 0.5rem;
      padding: 0.8rem 2rem;
      width: 100%;
    }
  }
  
  .react-modal-filter-input{
  
    margin-top: 1em;
    display: flex;
    flex-direction: column;
    
    label{
        font-weight: bold;
    }
    
    input{
       width: 17rem;
       height: 3rem;
       margin-top: 0.25rem;
       font-weight: 600;
       font-size: 1rem;
       color: var(--black);
       padding: 0.8125rem 1.125rem;
       border: 1px solid var(--gray-400);
       border-radius: 0.5rem;
       margin-right: 1.5rem;
    }
  }
  
  .react-modal-filter-input-type-matistis {
    margin-top: 1em;
    display: flex;
    flex-direction: column;
    margin-right: 1.5rem;
    
    label{
        font-weight: bold;
    }
    
  }

  .basic-multi-select-filter{
    width: 272px;
    
    .select__control {
        
        .select__value-container{
          min-height: 3rem;
        }
    }
  }

  .react-modal-filter-buttons-action{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    gap: 0.6rem;
    width: 85%;

    button{
      font-size: 1rem;
      width: 155px;
      font-weight: 700;
      color: var(--white);
      border: unset;
      background: var(--pink-400);
      border-radius: 0.5rem;
      padding: 0.8rem 2rem;
      width: 100%;
    }
  }

  .react-modal-protocol-content{
    /* margin-top: 1rem; */
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    position: relative;
    height: 90%;

    h2{
      max-width: 371px;
      text-align: center;
      font-size: 1.75rem;
      font-weight: 700;
    }

    h3{
      max-width: 219px;
      text-align: center;
      font-size: 1.125rem;
      font-weight: 700;
    }

    h4{
      margin-top: 1.5rem;
      max-width: 229px;
      text-align: center;
      font-size: 1.125rem;
      font-weight: 500;
    }

    iframe{
      margin: 3rem;
    }
  }

  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
  .option-radio{
    display: flex;
    margin-bottom: 15px;
    input {
      margin-bottom: 0;
      margin-right: 15px;
    }
  }
  img.img-view{
    width: 100%;
    display: block;
    height: auto;
    position: relative;
    top: 0;
  }


  .ReactModal__Content {
    outline: none;
  }

  .bezerra-new-illness-button-modal{
    display: flex;
    margin-top: 30px!important;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
    font-size: 18px!important;
  }
  .react-modal-filter-input.filter input {/* width: 100%; */margin: 0;}
  .filter-block .loading {
    position: absolute;
    right: calc(50% - 300px);
    top: -17px;
  }

  .filter-block {
      position: relative;
  }

  .filter-block-cow-record {
      position: relative;
      margin-left: 1rem;
  }

  .filter-block-ghaphs {
      position: relative;
      margin-top: -1.2rem;
  }

  .filter-block-videos{
    display: flex;
  }

  .react-modal-help-content-buttons {
    padding: 15px;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-around;
    input{
      width: 100%;
    }
    button {
        width: 100%;
        padding: 15px;
        height: auto;
        margin-left: 0!important;
        & .sub-button{
          display: none;
        }
         &.active {
           & .sub-button{
            display: block;
             &.active {
               background: var(--pink-400);
                color: var(--white);
             }
          }
          border: none;
          padding: 1rem;
          background: var(--pink-400);
          box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
          border-radius: 8px;
          /* margin-left: 1rem;
          margin-right: 1rem; */

          font-size: 1rem;
          font-weight: 700;
          color: var(--white);

          /* + .buttons-manual-automative{
              margin-left: 1rem;
            } */

          :hover{
            background: var(--pink-400);
            color: var(--white);
          }
        }
    }
  }

  .customMenuHeaderLink {
    text-decoration: none;
    width: 170px;
    height: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 10px;

    span {
      font-size: 14px;
      color: rgb(52, 58, 64);
      font-weight: 500;
    }
  }

  .customMenuHeaderLink:hover {
    background: #E9ECEF;
  }

  #menu-main {
    max-width: 380px;

    .user-menu-drop-title{
      gap: 10px;
      display: flex;
      padding: 0 10px;
      justify-content: flex-start;
      align-items: center;
      padding: 1rem;
      border-bottom: 1px solid var(--gray-200);

      .divSiglaName{
        text-transform: none;
        font-size: 10px;
        background-color: #ED0772 !important;
        border-radius: 30px;
        color: rgb(255, 255, 255) !important;
        font-weight: 700;
        font-family: "Open Sans", sans-serif;
        text-decoration: none;
        height: 32px;
        width: 32px;
        min-width: 32px;
        line-height: normal;
        border: 2px solid #20597C;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      p {      
        margin: 0px;
        font-family: Roboto, Helvetica, Arial, sans-serif;
        line-height: 1.5;
        letter-spacing: 0.00938em;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p:nth-child(1) {      
        font-weight: 700;
        font-size: 14px;
      }

      p:nth-child(2) {      
        font-weight: 400;
        font-size: 13px;
      }

      p:nth-child(3) {      
        font-weight: 400;
        font-size: 13px;
      }

    }

    .menuMainItem {
      display: flex;
      -webkit-box-pack: justify;
      justify-content: flex-start;
      -webkit-box-align: center;
      align-items: center;
      padding: 1rem;
      border-bottom: 1px solid var(--gray-200);
      cursor: pointer;
      transition: background 0.2s;
      gap: 10px;
      text-decoration: none;
    }
  
  }


    
`
